<template>
  <div id="app" class="app-root">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
html,
body,
#app,
.app-root {
  min-height: 100vh;
  margin: 0;
  background: #f7f8fa;
}
</style>
